import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/profileApi';
export const fetchProfile  = createAsyncThunk('profile/fetch',  async (_, {rejectWithValue}) => {
  try { return (await api.getProfile()).data.data; } catch(e) { return rejectWithValue(e.response?.data?.message); }
});
export const updateProfile = createAsyncThunk('profile/update', async (dto, {rejectWithValue}) => {
  try { return (await api.updateProfile(dto)).data.data; } catch(e) { return rejectWithValue(e.response?.data?.message); }
});
const s = createSlice({ name: 'profile', initialState: { data: null, loading: false, error: null },
  reducers: { clearError: s => { s.error = null; } },
  extraReducers: b => {
    b.addCase(fetchProfile.pending, s => { s.loading = true; })
     .addCase(fetchProfile.fulfilled, (s,{payload}) => { s.loading = false; s.data = payload; })
     .addCase(fetchProfile.rejected, (s,{payload}) => { s.loading = false; s.error = payload; });
    b.addCase(updateProfile.pending, s => { s.loading = true; })
     .addCase(updateProfile.fulfilled, (s,{payload}) => { s.loading = false; s.data = payload; })
     .addCase(updateProfile.rejected, (s,{payload}) => { s.loading = false; s.error = payload; });
  }
});
export const { clearError } = s.actions;
export default s.reducer;
